import _ from "lodash";
import { useEffect, useState } from "react";
import { getParsedLocalSuggestionsWithTimeout } from "./Utils";

const localSuggestionsCache = new Map();

const getMemoizationParams = params => {
  const {
    term = "",
    module,
    courses: coursesNode,
    curriculumProgramType,
    orgId,
  } = params;
  return {
    hasTerm: !_.isEmpty(term),
    module,
    courses: _.join(_.map(coursesNode, "id")),
    curriculumProgramType: _.join(curriculumProgramType),
    orgId,
  };
};

const useLocalSuggestions = ({
  t,
  module,
  searchText,
  orgId,
  courses,
  curriculumProgramType,
}) => {
  const [localSuggestions, setLocalSuggestions] = useState([]);
  const [isLocalSuggestionsLoading, setIsLocalSuggestionsLoading] = useState(
    false
  );

  useEffect(() => {
    const params = {
      term: searchText,
      module,
      courses,
      orgId,
      curriculumProgramType,
    };
    getLocalSuggestions(params);
  }, [Boolean(searchText), module, _.join(_.map(courses, "id"))]);

  const getLocalSuggestions = params => {
    const memoizationParams = getMemoizationParams(params);
    const paramsKey = JSON.stringify(memoizationParams);

    if (localSuggestionsCache.has(paramsKey)) {
      onLocalSuggestionComputationComplete({
        data: localSuggestionsCache.get(paramsKey),
        paramsKey,
      });
      return;
    }
    setIsLocalSuggestionsLoading(true);
    getParsedLocalSuggestionsWithTimeout({
      t,
      onComplete: data =>
        onLocalSuggestionComputationComplete({ data, paramsKey }),
      ...params,
    });
  };

  const onLocalSuggestionComputationComplete = ({ data, paramsKey }) => {
    setLocalSuggestions(data);
    setIsLocalSuggestionsLoading(false);
    localSuggestionsCache.set(paramsKey, data);
  };

  return {
    localSuggestions,
    isLoading: isLocalSuggestionsLoading,
  };
};

export default useLocalSuggestions;
